/* Native <details> supplies the menu even if this enhancement fails to load. */
(function () {
  if (window.nhNavigationReady) return;
  window.nhNavigationReady = true;

  function closeMenus(root) {
    root.querySelectorAll('details[open]').forEach(function (item) { item.open = false; });
  }

  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-nh-navigation]').forEach(function (root) {
      if (!root.contains(event.target)) closeMenus(root);
      else if (event.target.closest('a')) closeMenus(root);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const open = event.target.closest('[data-nh-navigation] details[open]');
    if (open) {
      closeMenus(open);
      open.open = false;
      open.querySelector('summary').focus();
    }
  });

  function initCart() {
    if (window.theme && theme.settings.cartType === 'drawer' && theme.CartDrawer && !document.body.classList.contains('template-cart')) {
      new theme.CartDrawer();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCart, { once: true });
  else initCart();
})();
